// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { getType } from 'typesafe-actions';
import { ProductCard } from '../../components/NewCard/types';
import { PaginationListResponse } from '../../types/Model';
import { KeywordTitle } from '../actionCreators/search/searchChallengesKeywordActions';

import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface SearchChallengesState {
  challengesListData: PaginationListResponse<ProductCard>;
  challengesKeyword: { [key: string]: KeywordTitle[] };
  isFetching: boolean;
  isFetchingMore: boolean;
  isKeywordFetching: boolean;
  error?: Error;
  keywordError?: Error;
}

const {
  searchChallengesActions,
  searchChallengesKeywordActions
} = actionCreatorsList;

export const initialSearchChallengesState: SearchChallengesState = {
  challengesListData: {
    list: [],
    totalPage: 0,
    count: 0,
    page: 0,
    limit: 0,
  },
  challengesKeyword: {},
  isFetching: true,
  isFetchingMore: false,
  isKeywordFetching: true
};

export default function (state = initialSearchChallengesState, action: RootAction): SearchChallengesState {
  switch (action.type) {
    /** searchChallengesActions will trigger when new condition is given */
    case getType(searchChallengesActions.request): {
      return {
        ...state,
        isFetching: true,
        isFetchingMore: action.payload.page > 1,
        error: undefined,
      };
    }
    case getType(searchChallengesActions.success): {
      const {
        list,
        totalPage,
        count,
        page,
        limit,
      } = action.payload;

      const nextList = page === 1 ? list : [...state.challengesListData.list, ...list];
      return {
        ...state,
        isFetching: false,
        isFetchingMore: false,
        challengesListData: {
          list: nextList,
          totalPage,
          count,
          page,
          limit,
        },
      };
    }
    case getType(searchChallengesActions.failure): {
      return {
        ...state,
        isFetching: false,
        isFetchingMore: false,
        error: action.payload.error
      };
    }
    case getType(searchChallengesKeywordActions.request): {
      return {
        ...state,
        isKeywordFetching: true,
        keywordError: undefined
      };
    }
    case getType(searchChallengesKeywordActions.success): {
      const { name = '', list, count } = action.payload;
      const nextChallengesKeyword = state.challengesKeyword;
      nextChallengesKeyword[name] = list;
      return {
        ...state,
        isKeywordFetching: false,
        challengesKeyword: nextChallengesKeyword
      };
    }
    case getType(searchChallengesKeywordActions.failure): {
      return {
        ...state,
        isKeywordFetching: false,
        keywordError: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
